import { useCallback } from 'react';
import { useRegisterContext } from '../reducer/useRegister';

export const useAcceptHealthAuth = () => {
  const [state, dispatch] = useRegisterContext();
  const {
    data: { phoneNumber },
  } = state;
  return useCallback(() => {
    dispatch({ type: 'REQUESTING_REGISTRATION_CODE', phoneNumber });
  }, [phoneNumber, dispatch]);
};
